/* @flow */

import { partialRight } from 'ramda';
import { useSelector } from 'react-redux';

import { getTopic } from 'src/shared/domain/topic/selector/topicSelectors';

import type { Topic } from '@braindate/domain/lib/topic/type';

export default function useTopic(id: number): Topic | void {
  return useSelector(partialRight(getTopic, [{ id }]));
}
